// TanStack Start app config: client-side rendering (CSR) only — routes render in the
// browser after the SPA shell loads. Matches vite TanStack Start `spa` mode + static Docker image.
import { createStart } from '@tanstack/react-start'

export const startInstance = createStart(() => ({
  defaultSsr: false,
}))
